<template>
  <div>
    <Row type="flex" justify="center">
      <Col>
        <h3
          style="color:#893448;font-size:18px;letter-spacing:0.4px;white-space: nowrap;"
        >{{ table_title }}
        </h3>
      </Col>
    </Row>
    <Row>
      <Col span="24">
        <Tabs v-model="current_tabs_name" type="card" @on-click="current_tabs_click" name="tab1">
          <TabPane :label="tabs_label1" name="name1" tab="tab1">
            <Row type="flex"  align="middle">
              <Col offset=20 span=2>
              <Input search maxlength="60" placeholder="搜索关键字" v-model="current_strategy_search_model" 
                @on-blur="current_strategy_search_click" 
                @on-search="current_strategy_search_click"/>
              </Col>
              <Col span=1>
                <Tooltip transfer content="清空搜索项" :delay="1500">
                  <Button style="font-size:20px;color:#0099FF;box-shadow:none" type="text" size="large" 
                    shape="circle" icon="ios-close"
                    @click="current_strategy_search_clear"
                  ></Button>
                </Tooltip>
              </Col>
              <Col span=1>
              <Tooltip transfer content="刷新当前策略" :delay="1500">
                  <Button style="font-size:20px;color:#0099FF;box-shadow:none" type="text" size="large" 
                    shape="circle" icon="md-refresh" :loading="this.loop_update_current_strategy_loading"
                    @click="this.update_current_strategy_click"
                  ></Button>
              </Tooltip>
              </Col>
            </Row>
            <v-table
              :title="this.current_strategy_title"
              :title_info="this.current_strategy_info"
              :table_columns="this.current_strategy_columns"
              :table_data="this.current_strategy_data_show"
              :table_ref="this.current_strategy_ref"
              :max_height="750"
              :init_table="this.current_strategy_init_table_func"
              :table_name_array="this.current_strategy_array"
              :show_top="false"
              :show_page="false"
              :table_page_size="100"
            ></v-table>
            <v-params-confirm-view
            :open_modal_switch="params_confirm_modal_view_msg['open_modal_switch']"
            :title="params_confirm_modal_view_msg['title']"
            :params="params_confirm_modal_view_msg['params']"
            :allow_msg_name_description_index = "params_confirm_modal_view_msg['allow_msg_name_description_index']"
            v-on:params_confirm_click="params_modal_confirm_click"
            >
            </v-params-confirm-view>
          </TabPane>
          <TabPane :label="tabs_label2" name="name2" tab="tab1">
            <Row type="flex" align="middle">
              <Col offset=20 span=2>
              <Input search maxlength="60" placeholder="搜索关键字" v-model="historical_strategy_search_model" 
                @on-blur="historical_strategy_search_click" 
                @on-search="historical_strategy_search_click"/>
              </Col>
              <Col span=1>
                <Tooltip transfer content="清空搜索项" :delay="1500">
                  <Button style="font-size:20px;color:#0099FF;box-shadow:none" type="text" size="large" 
                    shape="circle" icon="ios-close"
                    @click="historical_strategy_search_clear"
                  ></Button>
                </Tooltip>
              </Col>
              <Col span=1>
              <Tooltip transfer content="刷新历史策略" :delay="1500">
                  <Button style="font-size:20px;color:#0099FF;box-shadow:none" type="text" size="large" 
                    shape="circle" icon="md-refresh" :loading="loop_update_historical_strategy_loading"
                    @click="update_current_strategy_click"
                  ></Button>
              </Tooltip>
              </Col>
            </Row>
            <Row>
              <v-table
                :title="this.historical_strategy_title"
                :title_info="this.historical_strategy_info"
                :table_columns="this.historical_strategy_columns"
                :table_data="this.historical_strategy_data_show"
                :table_ref="this.historical_strategy_ref"
                :max_height="750"
                :init_table="this.historical_strategy_init_table_func"
                :table_name_array="this.historical_strategy_array"
                :show_top="false"
                :show_page="false"
                :table_page_size="100"
              ></v-table>
            </Row>
          </TabPane>
          <TabPane :label="tabs_label3" name="name3" tab="tab1">
            <div>
            <Row type="flex" justify="center">
              <Col>
                <h3
                  style="color:#893448;font-size:13px;letter-spacing:0.4px;white-space:nowrap;"
                >{{ create_or_alter_table_title }}
                </h3>
              </Col>
            </Row>
              <Row>
                <Col>
                  <v-flexible-render-modal-view
                      :paras='modal_view_msg["paras"]'
                      :open_modal_switch='modal_view_msg["open_modal_switch"]'
                      :uuid='modal_view_msg["uuid"]'
                      :name='modal_view_msg["name"]'
                      :modal_type='modal_view_msg["m_type"]'
                      :open_or_close='modal_view_msg["open_or_close"]'
                      :execute_percent='modal_view_msg["execute_percent"]'
                      v-on:modal_click="modal_click"
                    >
                  </v-flexible-render-modal-view>
                  <v-confirm-view
                    :params='confirm_modal_view_msg["params"]'
                    :title='confirm_modal_view_msg["title"]'
                    :open_modal_switch='confirm_modal_view_msg["open_modal_switch"]'
                    v-on:modal_confirm_click="modal_confirm_click">
                    </v-confirm-view>
                  <Tabs v-model="create_or_alter_table_current_tabs_name" type="card" name="tab2">
                    <TabPane label="开仓信号" name="create_name1" tab="tab2">
                      <Row>
                        <Col span="4" offset="20">
                            <v-flexible-render-dropdown-view
                              :allow_msg="this.allow_msg"
                              m_type="sign"
                              open_or_close="open"
                              v-on:dropdown_click="flexible_render_dropdown_click"
                            ></v-flexible-render-dropdown-view>
                        </Col>
                      </Row>
                      <Row style="height:5px;"></Row>
                        <v-table
                          :title="this.create_or_alter_table_name1_title"
                          :title_info="this.create_or_alter_table_name1_info"
                          :table_columns="this.create_or_alter_table_name1_columns"
                          :table_data="this.create_or_alter_table_name1_data"
                          :table_ref="this.create_or_alter_table_name1_ref"
                          :max_height="750"
                          :init_table="this.create_or_alter_table_name1_init_table_func"
                          :table_name_array="this.create_or_alter_table_name1_array"
                          :show_top="false"
                          :show_page="false"
                          :table_page_size="100"
                        ></v-table>
                    </TabPane>
                    <TabPane label="平仓信号" name="create_name2" tab="tab2">
                      <Row>
                        <Col span="4" offset="20">
                            <v-flexible-render-dropdown-view
                              :allow_msg="this.allow_msg"
                              m_type="sign"
                              open_or_close="close"
                              v-on:dropdown_click="flexible_render_dropdown_click"
                            ></v-flexible-render-dropdown-view>
                        </Col>
                      </Row>
                      <Row style="height:5px;"></Row>
                      <v-table
                          :title="this.create_or_alter_table_name2_title"
                          :title_info="this.create_or_alter_table_name2_info"
                          :table_columns="this.create_or_alter_table_name2_columns"
                          :table_data="this.create_or_alter_table_name2_data"
                          :table_ref="this.create_or_alter_table_name2_ref"
                          :max_height="750"
                          :init_table="this.create_or_alter_table_name2_init_table_func"
                          :table_name_array="this.create_or_alter_table_name2_array"
                          :show_top="false"
                          :show_page="false"
                          :table_page_size="100"
                        ></v-table>
                    </TabPane>
                    <TabPane label="止盈/止损设置" name="create_name3" tab="tab2">
                      <Row>
                        <Col span="4" offset="20">
                            <v-flexible-render-dropdown-view
                              :allow_msg="this.allow_msg"
                              m_type="default"
                              open_or_close="close"
                              v-on:dropdown_click="flexible_render_dropdown_click"
                            ></v-flexible-render-dropdown-view>
                        </Col>
                      </Row>
                      <Row style="height:5px;"></Row>
                      <v-table
                          :title="this.create_or_alter_table_name3_title"
                          :title_info="this.create_or_alter_table_name3_info"
                          :table_columns="this.create_or_alter_table_name3_columns"
                          :table_data="this.create_or_alter_table_name3_data"
                          :table_ref="this.create_or_alter_table_name3_ref"
                          :max_height="750"
                          :init_table="this.create_or_alter_table_name3_init_table_func"
                          :table_name_array="this.create_or_alter_table_name3_array"
                          :show_top="false"
                          :show_page="false"
                          :table_page_size="100"
                        ></v-table>
                    </TabPane>
                    <TabPane label="订单执行设置" name="create_name4" tab="tab2">
                      <Row>
                        <Col span="4" offset="20">
                            <v-flexible-render-dropdown-view
                              :allow_msg="this.allow_msg"
                              m_type="function_type"
                              open_or_close="close"
                              v-on:dropdown_click="flexible_render_dropdown_click"
                            ></v-flexible-render-dropdown-view>
                        </Col>
                      </Row>
                      <Row style="height:5px;"></Row>
                      <v-table
                          :title="this.create_or_alter_table_name4_title"
                          :title_info="this.create_or_alter_table_name4_info"
                          :table_columns="this.create_or_alter_table_name4_columns"
                          :table_data="this.create_or_alter_table_name4_data"
                          :table_ref="this.create_or_alter_table_name4_ref"
                          :max_height="750"
                          :init_table="this.create_or_alter_table_name4_init_table_func"
                          :table_name_array="this.create_or_alter_table_name4_array"
                          :show_top="false"
                          :show_page="false"
                          :table_page_size="100"
                        ></v-table>
                    </TabPane>
                    <TabPane label="绑定账户设置" name="create_name5" tab="tab2" :disabled="create_or_alter_table_disabled">
                      <Row>
                        <Col span="4" offset="20">
                            <v-flexible-render-dropdown-view
                              :allow_msg="this.allow_msg"
                              m_type="account_msg"
                              open_or_close="close"
                              v-on:dropdown_click="flexible_render_dropdown_click"
                            ></v-flexible-render-dropdown-view>
                        </Col>
                      </Row>
                      <Row style="height:5px;"></Row>
                      <div style="min-height:250px;">
                      <v-table
                          :title="this.create_or_alter_table_name5_title"
                          :title_info="this.create_or_alter_table_name5_info"
                          :table_columns="this.create_or_alter_table_name5_columns"
                          :table_data="this.create_or_alter_table_name5_data"
                          :table_ref="this.create_or_alter_table_name5_ref"
                          :max_height="750"
                          :init_table="this.create_or_alter_table_name5_init_table_func"
                          :table_name_array="this.create_or_alter_table_name5_array"
                          :show_top="false"
                          :show_page="false"
                          :table_page_size="100"
                        ></v-table>
                      </div>
                    </TabPane>
                  </Tabs>
                </Col>
              </Row>
              <Row style="height:15px;"></Row>
              <Row type="flex" justify="space-around" align="bottom">
                <Col offset="12">
                  <Button type="success" shape="circle" size="large" @click="create_or_alter_table_click_1">录入ID</Button>
                </Col>
                <Col>
                  <Button type="success" shape="circle" size="large" @click="create_or_alter_table_click_2">{{create_or_alter_table_button_title}}</Button>
                </Col>
                <Col>
                  <Button type="success" shape="circle" size="large" @click="create_or_alter_table_click_3">重置信号</Button>
                </Col>
                <Col>
                  <Button type="success" shape="circle" size="large" @click="create_or_alter_table_click_4">后台参数</Button>
                </Col>
                <Col span="1">
                </Col>
              </Row>
            </div>
          </TabPane>
          <TabPane :label="tabs_label4" name="name4" tab="tab1">
            <Row type="flex" justify="center" align="middle">
              <Col offset="20">
                  <v-flexible-render-dropdown-view
                    :allow_msg="this.all_strategy"
                    m_type="strategy_msg"
                    :drop_down_title="this.supervisor_strategy_drop_down_title"
                    v-on:dropdown_click="flexible_render_dropdown_click"
                    :icon_flag="false"
                  ></v-flexible-render-dropdown-view>
              </Col>
              <Col>
                <Button style="font-size:20px;color:#0099FF;box-shadow:none" type="text" size="large" 
                  shape="circle" icon="md-refresh" :loading="this.loop_update_supervisor_button_loading"
                  @click="this.loop_update_supervisor_button_click"
                  ></Button>
              </Col>
            </Row>
            <v-table
              :title="this.supervisor_strategy_title"
              :title_info="this.supervisor_strategy_info"
              :table_columns="this.supervisor_strategy_columns"
              :table_data="this.supervisor_strategy_data"
              :table_ref="this.supervisor_strategy_ref"
              :max_height="750"
              :init_table="this.supervisor_strategy_init_table_func"
              :table_name_array="this.supervisor_strategy_array"
              :show_top="false"
              :show_page="false"
              :table_page_size="100"
            ></v-table>
          </TabPane>
        </Tabs>
      </Col>
    </Row>
  </div>
</template>

<script>
import store from '../store';
import table_view from "../components/TableView.vue";
import flexible_render_table_view from "../components/FlexibleStrategy/TableRenderSign.vue";
import flexible_render_modal_view from "../components/FlexibleStrategy/ModalRenderSign.vue";
import flexible_render_slider_view from "../components/FlexibleStrategy/SliderRenderSign.vue";
import flexible_render_dropdown_view from "../components/FlexibleStrategy/DropdownRender.vue";
import flexible_render_modal_view_confirm from "../components/FlexibleStrategy/ModalRenderConfirm.vue";
import flexible_render_modal_view_params_confirm from "../components/FlexibleStrategy/ModalRenderConfirmParam.vue";
import flexible_render_table_view_amount from "../components/FlexibleStrategy/TableRenderShowAmount.vue"
//import func from 'vue-editor-bridge';

export default {
  name: "flexible_strategy",
  components: {
     "v-table": table_view,
     "v-flexible-render-table-view": flexible_render_table_view,
     "v-flexible-render-modal-view": flexible_render_modal_view,
     "v-flexible-render-dropdown-view":flexible_render_dropdown_view,
     "v-confirm-view":flexible_render_modal_view_confirm,
     "v-params-confirm-view":flexible_render_modal_view_params_confirm,
     "v-flexible-render-slider-view":flexible_render_slider_view,
  },
  data() {
    return {
      table_title:"灵活策略运行管理",
      create_or_alter_table_title:"创建新策略",
      create_or_alter_table_button_title:"确认创建",
      create_or_alter_table_disabled:false,
      current_tabs_name:"name1",
      prefix:"fle_",
      loop_update_supervisor_strategy_time_count:5,
      loop_update_supervisor_strategy_time_count_set:30,
      loop_update_current_strategy_click_time_count:5,
      loop_update_current_strategy_click_time_count_set:60,
      loop_update_supervisor_button_loading:false,
      loop_update_current_strategy_loading:false,
      loop_update_historical_strategy_loading:false,
      create_or_alter_table_current_tabs_name:"create_name1",
      tabs_label1:"当前策略",
      tabs_label2:"历史策略",
      tabs_label3:"创建/修改",
      tabs_label4:"策略监控",

      // 展示在创建/修改页面上策略信息
      // 关键项参数，会频繁变化
      create_or_alter_table_msg:[],
      // 循环执行
      timer: null,
      // 控制策略允许添加的各项参数
      allow_msg:null,
      // 记录信号与中文描述信息的映射
      allow_msg_name_description_index:{},
      // 控制策略允许添加的所有策略信息
      all_strategy:null,
      // 控制账户允许操作的策略列表
      strategy_msg:null,
      // 用户当前选择的用以修改的策略ID
      create_or_alter_table_strategy_id:"-1",
      // 用户当前选择的需要监控执行进度的策略ID
      supervisor_strategy_id:"-1",
      // 特殊的UUID，用以同时控制所有account的开仓比例
      default_control_name5_uuid:"c95ad7f9-d263-4002-96f9-97412896c013",
      supervisor_strategy_drop_down_title:"选择一个策略",
      // 初始化modal的变量
      modal_view_msg: {
        "paras":[],
        "open_modal_switch":false,
        "open_or_close":"open",
        "uuid":"",
        "sign_name":"",
        "execute_percent":1
      },
      // 初始化用来确定的modal的变量
      confirm_modal_view_msg: {
        open_modal_switch:false,
        params:{},
        title:"",
      },
      // 初始化开启操作前，界面上的参数确定环节modal的变量
      params_confirm_modal_view_msg: {
        open_modal_switch:false,
        params:{},
        allow_msg_name_description_index:{},
        title:"",
      },
      
      current_strategy_search_model:"",
      current_strategy_title: "",
      current_strategy_info: [],
      current_strategy_columns: [],
      current_strategy_data: [],
      // 用来匹配搜索功能
      current_strategy_data_show:[],
      current_strategy_ref: "current_strategy_ref",
      current_strategy_array: [
        "策略ID",
        "名称",
        "描述",
        "参数",
        "标的",
        "策略状态",
        "运行操作",
        "其他操作"
      ],

      historical_strategy_search_model:"",
      historical_strategy_title: "",
      historical_strategy_info: [],
      historical_strategy_columns: [],
      historical_strategy_data: [],
      // 用来匹配搜索功能
      historical_strategy_data_show:[],
      historical_strategy_ref: "historical_strategy_ref",
      historical_strategy_array: [
        "策略ID",
        "名称",
        "描述",
        "参数",
        "标的",
        "运行操作",
        "其他操作"
      ],

      supervisor_strategy_title: "",
      supervisor_strategy_info: [],
      supervisor_strategy_columns: [],
      supervisor_strategy_data: [],
      supervisor_strategy_ref: "supervisor_strategy_ref",
      supervisor_strategy_array: [
        "账户编号",
        "方向",
        "仓位信息",
        "下单标的",
        "成本价",
        "现价",
        "止盈价",
        "止损价",
        "最大亏损估计(USDT)",
        "信息",
        "未实现盈亏(USDT)",
        "执行进度",
      ],

      create_or_alter_table_name1_title: "",
      create_or_alter_table_name1_info: [],
      create_or_alter_table_name1_columns: [],
      create_or_alter_table_name1_data: [],
      create_or_alter_table_name1_ref: "create_or_alter_table_name1_ref",
      create_or_alter_table_name1_array: [
        "信号ID",
        "信号名称",
        "信号描述",
        "信号参数",
        "执行效率",
        "操作"
      ],

      create_or_alter_table_name2_title: "",
      create_or_alter_table_name2_info: [],
      create_or_alter_table_name2_columns: [],
      create_or_alter_table_name2_data: [],
      create_or_alter_table_name2_ref: "create_or_alter_table_name2_ref",
      create_or_alter_table_name2_array: [
        "信号ID",
        "信号名称",
        "信号描述",
        "信号参数",
        "执行效率",
        "操作"
      ],

      create_or_alter_table_name3_title: "",
      create_or_alter_table_name3_info: [],
      create_or_alter_table_name3_columns: [],
      create_or_alter_table_name3_data: [],
      create_or_alter_table_name3_ref: "create_or_alter_table_name3_ref",
      create_or_alter_table_name3_array: [
        "信号ID",
        "信号名称",
        "信号描述",
        "信号参数",
        "执行效率",
        "操作"
      ],

      create_or_alter_table_name4_title: "",
      create_or_alter_table_name4_info: [],
      create_or_alter_table_name4_columns: [],
      create_or_alter_table_name4_data: [],
      create_or_alter_table_name4_ref: "create_or_alter_table_name4_ref",
      create_or_alter_table_name4_array: [
        "信号ID",
        "开仓/平仓阶段",
        "信号参数",
        "操作"
      ],

      create_or_alter_table_name5_title: "",
      create_or_alter_table_name5_info: [],
      create_or_alter_table_name5_columns: [],
      create_or_alter_table_name5_data: [],
      create_or_alter_table_name5_ref: "create_or_alter_table_name5_ref",
      create_or_alter_table_name5_array: [
        "uuid",
        "账户编号",
        "账户说明",
        "开仓比例",
        "操作"
      ],
    };
  },
  methods: {
    flexible_render_dropdown_click: function(value) {
      if (value["mode"] != "ok") {
        console.log("Wrong mode")
        return null
      }
      if (value["m_type"] === "account_msg") {
        if (value["paras"][0] === "all") {
          // 用户单击了添加所有账户按钮
          for (var i = 0; i < this.allow_msg["account_msg"].length; i++) {
            this.create_or_alter_table_msg.push({
              "type":value["m_type"],
              "name":value["name"],
              "paras":JSON.parse(JSON.stringify([this.allow_msg["account_msg"][i][0], 0.3])),
              "description":this.allow_msg["account_msg"][i][1],
              "uuid":this.get_uuid()
            })
          }
        } else {
          this.create_or_alter_table_msg.push({
            "type":value["m_type"],
            "name":value["name"],
            "paras":JSON.parse(JSON.stringify(value["paras"])),
            "description":value["description"],
            "uuid":this.get_uuid()
          })
        }
      } else if (value["m_type"] === "strategy_msg") {
        this.supervisor_strategy_id = value["paras"][0]
      } else if (value["m_type"] === "sign") {
        this.create_or_alter_table_msg.push({
          "type":value["m_type"],
          "name":value["name"],
          "paras":JSON.parse(JSON.stringify(value["paras"])),
          "open_or_close":value["open_or_close"],
          "execute_percent":1,
          "uuid":this.get_uuid()
        })
      } else {
        this.create_or_alter_table_msg.push({
          "type":value["m_type"],
          "name":value["name"],
          "paras":JSON.parse(JSON.stringify(value["paras"])),
          "open_or_close":value["open_or_close"],
          "execute_percent":1,
          "description":value["description"],
          "uuid":this.get_uuid()
        })
      }
      // 重新渲染表格
      this.update_create_or_alter_table_msg()
    },
    current_tabs_click: function(name) {
      this.current_tabs_name = name
      //用户单击了当前策略/历史策略/修改策略中的某一个
      if (name === "name3") {
        
      } else if (name === "name1") {
        setTimeout(async () => {
          if (this.supervisor_strategy_id != "-1") {
            let data = await this.create_or_alter_table_get_all_strategy(this.supervisor_strategy_id)
            if (data.length != 0 ) {
              this.all_strategy[this.supervisor_strategy_id.toString()] = data
              this.update_strategy_table_msg()
            }
          }
        }, 0)
      }
    },
    get_paras_msg: function(strategy_con) {
      // 根据策略的各项信号，返回一个可以给前端展示的长字符串
      // 用来快速概览策略的参数
      var open_paras_list = []
      var close_paras_list = []
      var function_type_list = []
      var default_list = []
      var account_msg_list = []
      for(var index in strategy_con) {
        var msg = strategy_con[index]
        // 填充创建/修改页签下的数据
        if (msg["type"] === "sign" && msg["open_or_close"] === "open") {
          open_paras_list.push([
            msg["name"], msg["paras"]
          ])
        } else if (msg["type"] === "sign" && msg["open_or_close"] === "close") {
          close_paras_list.push([
           msg["name"], msg["paras"]
          ])
        } else if (msg["type"] === "default") {
          default_list.push([
            msg["name"], msg["paras"]
          ])
        } else if (msg["type"] === "function_type") {
          function_type_list.push([
            msg["open_or_close"], msg["paras"]
          ])
        } else if (msg["type"] === "account_msg") {
          account_msg_list.push([
            msg["paras"][0], msg["paras"][1]
          ])
        }
      }
      var res = ""
      res += "开仓参数:\n\t"
      for (var i = 0; i < open_paras_list.length; i++) {
        res += open_paras_list[i][0] + ":\t " + open_paras_list[i][1] + "\n\t"
      }
      res = res.substring(0, res.length - 1)
      res += "----------------------------------------------\n平仓参数:\n\t"
      for (var i = 0; i < close_paras_list.length; i++) {
        res += close_paras_list[i][0] + ":\t " + close_paras_list[i][1] + "\n\t"
      }
      res = res.substring(0, res.length - 1)
      res += "----------------------------------------------\n固定参数:\n\t"
      for (var i = 0; i < default_list.length; i++) {
        if (default_list[i][0] == "stop_gain") {
          res += default_list[i][0] + ":\t " + this.$mul(Number(default_list[i][1]), 100)+"%" + "\n\t"
        } else {
          res += default_list[i][0] + ":\t " + this.$mul(Number(default_list[i][1][0]), 100)+"%" + ", " + this.$mul(Number(default_list[i][1][1]), 100) +"%"+ "\n\t"
        }
      }
      res = res.substring(0, res.length - 1)
      res += "----------------------------------------------\n订单执行参数:\n\t"
      var function_type_index = store.state.function_type_index
      for (var i = 0; i < function_type_list.length; i++) {
        res += function_type_list[i][0] + ":\t " + function_type_index[function_type_list[i][1][0]] + 
          "," + this.$mul(Number(function_type_list[i][1][1]), 10000) + "‱," + this.$mul(Number(function_type_list[i][1][2]), 10000) + "‱\n\t"
      }
      res = res.substring(0, res.length - 1)
      res += "----------------------------------------------\n绑定账户参数:\n\t"
      for (var i = 0; i < account_msg_list.length; i++) {
        res += account_msg_list[i][0] + ":\t " + this.$mul(Number(account_msg_list[i][1]), 100)+"% 资金使用率" + "\n\t"
      }
      res = res.substring(0, res.length - 1)
      return res
    },
    get_strategy_msg: function(strategy_con) {
      // 对选择策略信息筛选，返回策略本身的内容
      for(var index in strategy_con) {
        var msg = strategy_con[index]
        if (msg["type"] === "strategy_msg") {
          // 当策略处于正在运行状态时，不允许更新绑定账户页签
          return msg
        }
      }
      return null
    },
    update_strategy_table_msg: function() {
      if (this.all_strategy == null || this.all_strategy.length === 0) {return null}
      // 清空之前已经填充的数据
      let current_strategy_data = []
      let historical_strategy_data = []
      // 根据all_strategy数据, 将数据更新到当前策略页面+历史策略页面上
      for(var str_id in this.all_strategy) {
        if (str_id.toString() === "-1") {
            continue
        }
        let strategy_con = this.all_strategy[str_id]
        let paras_msg = this.get_paras_msg(strategy_con)
        let strategy_msg = this.get_strategy_msg(strategy_con)["paras"]
        if (["0", "1"].indexOf(strategy_msg["current_status_code"].toString()) != -1) {
          current_strategy_data.push([
            str_id, strategy_msg["name"], strategy_msg["description"], paras_msg, 
            strategy_msg["current_symbol"], strategy_msg["current_status_code"], ""
          ])
        } else if(["2"].indexOf(strategy_msg["current_status_code"].toString()) != -1) {
          historical_strategy_data.push([
            str_id, strategy_msg["name"], strategy_msg["description"], paras_msg, 
            strategy_msg["current_symbol"], strategy_msg["current_status_code"], ""
          ])
        }
      }
      this.current_strategy_data = current_strategy_data
      this.historical_strategy_data = historical_strategy_data
    },
    update_supervisor_strategy_table_msg: async function() {
      var msg = await this.supervisor_strategy_get_msg()
      if (msg === null || msg === undefined) {
        return null
      }
      // 清空之前已经填充的数据
      this.supervisor_strategy_data = []
      // 根据supervisor_strategy_get_msg接口的数据, 将数据更新到监控上
      if (this.supervisor_strategy_id.toString() == "-1") {
        return null
      }
      for (var i = 0; i < msg.length; i++) {
        this.supervisor_strategy_data.push(msg[i])
      }
    },
    update_create_or_alter_table_msg: function() {
      if (this.create_or_alter_table_msg.length === 0) {
        return null
      }
      this.create_or_alter_table_disabled = false
      this.create_or_alter_table_msg = 
        this.check_account_msg(this.create_or_alter_table_msg)
      // 将存储的create_or_alter_table_msg数据刷新到表格内
      // 清空之前已经填充的数据
      this.create_or_alter_table_name1_data = []
      this.create_or_alter_table_name2_data = []
      this.create_or_alter_table_name3_data = []
      this.create_or_alter_table_name4_data = []
      this.create_or_alter_table_name5_data = []
      //填充各个子页面的数据
      for(var index in this.create_or_alter_table_msg) {
        var msg = this.create_or_alter_table_msg[index]
        // 填充创建/修改页签下的数据
        if (msg["type"] === "sign" && msg["open_or_close"] === "open") {
          this.create_or_alter_table_name1_data.push([
            msg["uuid"], msg["name"], this.allow_msg_name_description_index[msg["name"]], msg["paras"], msg["execute_percent"], ""
          ])
        } else if (msg["type"] === "sign" && msg["open_or_close"] === "close") {
          this.create_or_alter_table_name2_data.push([
            msg["uuid"], msg["name"], this.allow_msg_name_description_index[msg["name"]], msg["paras"], msg["execute_percent"], ""
          ])
        } else if (msg["type"] === "default") {
          this.create_or_alter_table_name3_data.push([
            msg["uuid"], msg["name"], this.allow_msg_name_description_index[msg["name"]], msg["paras"], 1, ""
          ])
        } else if (msg["type"] === "function_type") {
          this.create_or_alter_table_name4_data.push([
            msg["uuid"], msg["open_or_close"], msg["paras"], ""
          ])
        } else if (msg["type"] === "account_msg") {
          this.create_or_alter_table_name5_data.push([
            msg["uuid"], msg["paras"][0], msg["description"], msg["paras"][1], ""
          ])
          this.create_or_alter_table_name5_data.sort(function(a, b){return a[1] - b[1]})
        } else if (msg["type"] === "strategy_msg" && msg["paras"]["current_status_code"].toString() == "1") {
          // 当策略处于正在运行状态时，不允许更新绑定账户页签
          this.create_or_alter_table_disabled = true
        }
      }
      // 额外添加一个总控，用以同时调整所有账户的下单比例
      if (this.create_or_alter_table_name5_data.length == 0) {
        this.create_or_alter_table_name5_data.push([
          this.default_control_name5_uuid, "", "", 0.3, ""
        ])
      } else {
        this.create_or_alter_table_name5_data.push([
          this.default_control_name5_uuid, "", "", this.create_or_alter_table_name5_data[0][3], ""
        ])
      }
    },
    create_or_alter_table_click_1: function() {
      // 单击了录入ID按钮
      this.modal_view_msg["uuid"] = this.create_or_alter_table_strategy_id
      this.modal_view_msg["name"] = ""
      this.modal_view_msg["m_type"] = "select_strategy_msg"
      this.modal_view_msg["paras"] = JSON.parse(JSON.stringify(this.all_strategy))
      this.modal_view_msg["execute_percent"] = 1
      this.modal_view_msg["open_or_close"] = "close"
      this.modal_view_msg["open_modal_switch"] = true
    },
    create_or_alter_table_click_2: function() {
      // 单击了创建/修改按钮
      // 弹出最后几步修正项,
      // 打开指标设置页面modal
      var value = null
      let acc_count = 0
      for (var i = 0; i < this.create_or_alter_table_msg.length; i++) {
          if (this.create_or_alter_table_msg[i]["type"] === "strategy_msg") {
            value = JSON.parse(JSON.stringify(this.create_or_alter_table_msg[i]))
          } else if (this.create_or_alter_table_msg[i]["type"] === "account_msg") {
            acc_count += 1
          }
      }
      if (value === null || value === undefined) {
        console.log("Wrong create_or_alter_table_msg")
        return null
      }
      let paras = value["paras"]
      paras["acc_count"] = acc_count
      paras["create_or_alter_table_disabled"] = this.create_or_alter_table_disabled
      this.modal_view_msg["uuid"] = this.create_or_alter_table_strategy_id
      this.modal_view_msg["name"] = ""
      this.modal_view_msg["m_type"] = "strategy_msg"
      this.modal_view_msg["paras"] = paras
      this.modal_view_msg["execute_percent"] = 1
      this.modal_view_msg["open_or_close"] = "close"
      this.modal_view_msg["open_modal_switch"] = true
    },
    create_or_alter_table_click_3: function() {
      // 单击了重置按钮
      // 重新加载参数
      this.create_or_alter_table_msg = 
        this.create_or_alter_table_get_strategy_msg(this.create_or_alter_table_strategy_id)
      this.update_create_or_alter_table_msg()
    },
    create_or_alter_table_click_4: async function() {
      // 单击了修改后台参数的按钮
      var value = null
      this.modal_view_msg["uuid"] = ""
      this.modal_view_msg["name"] = ""
      this.modal_view_msg["m_type"] = "tornado_setting"

      var formData = new FormData();
      formData.append("mode", "get_settings");
      let data = await this.$axios({
        url: this.$store.state.urlPort + "/flexible_strategy",
        method: "POST",
        data: formData,
      })
      this.modal_view_msg["paras"] = [JSON.parse(data["msg"])["default_strategy_id"].toString(), JSON.parse(JSON.stringify(this.all_strategy))]
      this.modal_view_msg["execute_percent"] = 1
      this.modal_view_msg["open_or_close"] = "close"
      this.modal_view_msg["open_modal_switch"] = true
    },
    create_or_alter_table_name1_init_table_func: function() {
      // 初始化创建/修改策略标签页内的开仓表格
      const name_array = this.create_or_alter_table_name1_array;
      this.create_or_alter_table_name1_columns = [];
      for (var i = 0; i < name_array.length; i++) {
        this.create_or_alter_table_name1_columns.push({
          title: name_array[i],
          key: name_array[i],
          align: "center"
        });
      }
      this.create_or_alter_table_name1_columns[0]["width"] = 100;
      this.create_or_alter_table_name1_columns[0]["tooltip"] = true;
      this.create_or_alter_table_name1_columns[2]["tooltip"] = true;
      this.create_or_alter_table_name1_columns[4]["render"] = (h, params) => {
        var value = params["row"][params["column"]["key"]]
        return h("div", [
          this.$createElement(
            "span",
            {
              props: {
               
              },
              style: {
                
              },
              on: {
                
              },
            },
            this.$mul(value, 100) + " %"
          )
        ]);
      };
      this.create_or_alter_table_name1_columns[5]["render"] = (h, params) => {
        return h("div", [
          this.$createElement(
            "Button",
            {
              props: {
                type: "success",
                size: "small",
                loading: false,
              },
              style: {
                marginRight: "5px"
              },
              on: {
                click: () => {
                  var value = this.create_or_alter_table_name1_data[params["index"]]
                  // 打开指标设置页面modal
                  this.modal_view_msg["uuid"] = value[0]
                  this.modal_view_msg["name"] = value[1]
                  this.modal_view_msg["m_type"] = "sign"
                  this.modal_view_msg["paras"] = value[3]
                  this.modal_view_msg["execute_percent"] = value[4]
                  this.modal_view_msg["open_or_close"] = "open"
                  this.modal_view_msg["open_modal_switch"] = true
                }
              },
            },
            "设置"
          ),
          this.$createElement(
            "Button",
            {
              props: {
                type: "warning",
                size: "small",
                loading: false
              },
              style: {
                marginRight: "5px"
              },
              on: {
                click: () => {
                  var uuid = this.create_or_alter_table_name1_data[params["index"]][0]
                  // 根据UUID删除该项，之后更新table
                  for (var i = 0; i < this.create_or_alter_table_msg.length; i++) {
                    if (this.create_or_alter_table_msg[i]["uuid"] === uuid) {
                        this.create_or_alter_table_msg.splice(i, 1)
                        break
                    }
                  }
                  this.update_create_or_alter_table_msg()
                }
              }
            },
            "删除"
          )
        ]);
      };
    },
    create_or_alter_table_name2_init_table_func: function() {
      // 初始化创建/修改策略标签页内的平仓表格
      const name_array = this.create_or_alter_table_name2_array;
      this.create_or_alter_table_name2_columns = [];
      for (var i = 0; i < name_array.length; i++) {
        this.create_or_alter_table_name2_columns.push({
          title: name_array[i],
          key: name_array[i],
          align: "center"
        });
      }
      this.create_or_alter_table_name2_columns[0]["width"] = 100;
      this.create_or_alter_table_name2_columns[0]["tooltip"] = true;
      this.create_or_alter_table_name2_columns[2]["tooltip"] = true;
      this.create_or_alter_table_name2_columns[4]["render"] = (h, params) => {
        var value = params["row"][params["column"]["key"]]
        return h("div", [
          this.$createElement(
            "span",
            {
              props: {
               
              },
              style: {
                
              },
              on: {
                
              },
            },
            this.$mul(value, 100) + " %"
          )
        ]);
      };
      this.create_or_alter_table_name2_columns[5]["render"] = (h, params) => {
        return h("div", [
          this.$createElement(
            "Button",
            {
              props: {
                type: "success",
                size: "small",
                loading: false,
              },
              style: {
                marginRight: "5px"
              },
              on: {
                click: () => {
                  var value = this.create_or_alter_table_name2_data[params["index"]]
                  // 打开指标设置页面modal
                  this.modal_view_msg["uuid"] = value[0]
                  this.modal_view_msg["name"] = value[1]
                  this.modal_view_msg["m_type"] = "sign"
                  this.modal_view_msg["paras"] = value[3]
                  this.modal_view_msg["execute_percent"] = value[4]
                  this.modal_view_msg["open_or_close"] = "close"
                  this.modal_view_msg["open_modal_switch"] = true
                }
              },
            },
            "设置"
          ),
          this.$createElement(
            "Button",
            {
              props: {
                type: "warning",
                size: "small",
                loading: false
              },
              style: {
                marginRight: "5px"
              },
              on: {
                click: () => {
                  var uuid = this.create_or_alter_table_name2_data[params["index"]][0]
                  // 根据UUID删除该项，之后更新table
                  for (var i = 0; i < this.create_or_alter_table_msg.length; i++) {
                    if (this.create_or_alter_table_msg[i]["uuid"] === uuid) {
                        this.create_or_alter_table_msg.splice(i, 1)
                        break
                    }
                  }
                  this.update_create_or_alter_table_msg()
                }
              }
            },
            "删除"
          )
        ]);
      };
    },
    create_or_alter_table_name3_init_table_func: function() {
      // 初始化创建/修改策略标签页内的平仓表格
      const name_array = this.create_or_alter_table_name3_array;
      this.create_or_alter_table_name3_columns = [];
      for (var i = 0; i < name_array.length; i++) {
        this.create_or_alter_table_name3_columns.push({
          title: name_array[i],
          key: name_array[i],
          align: "center"
        });
      }
      this.create_or_alter_table_name3_columns[0]["width"] = 100;
      this.create_or_alter_table_name3_columns[0]["tooltip"] = true;
      this.create_or_alter_table_name3_columns[4]["render"] = (h, params) => {
        var value = params["row"][params["column"]["key"]]
        return h("div", [
          this.$createElement(
            "span",
            {
              props: {
               
              },
              style: {
                
              },
              on: {
                
              },
            },
            this.$mul(value, 100) + " %"
          )
        ]);
      };
      this.create_or_alter_table_name3_columns[5]["render"] = (h, params) => {
        return h("div", [
          this.$createElement(
            "Button",
            {
              props: {
                type: "success",
                size: "small",
                loading: false,
              },
              style: {
                marginRight: "5px"
              },
              on: {
                click: () => {
                  var value = this.create_or_alter_table_name3_data[params["index"]]
                  // 打开指标设置页面modal
                  this.modal_view_msg["uuid"] = value[0]
                  this.modal_view_msg["name"] = value[1]
                  this.modal_view_msg["m_type"] = "default"
                  this.modal_view_msg["paras"] = value[3]
                  this.modal_view_msg["execute_percent"] = value[4]
                  this.modal_view_msg["open_or_close"] = "close"
                  this.modal_view_msg["open_modal_switch"] = true
                }
              },
            },
            "设置"
          )
        ]);
      };
    },
    create_or_alter_table_name4_init_table_func: function() {
      // 初始化创建/修改策略标签页内的平仓表格
      const name_array = this.create_or_alter_table_name4_array;
      this.create_or_alter_table_name4_columns = [];
      for (var i = 0; i < name_array.length; i++) {
        this.create_or_alter_table_name4_columns.push({
          title: name_array[i],
          key: name_array[i],
          align: "center"
        });
      }
      this.create_or_alter_table_name4_columns[0]["width"] = 100;
      this.create_or_alter_table_name4_columns[0]["tooltip"] = true;
      this.create_or_alter_table_name4_columns[1]["render"] = (h, params) => {
        var index = this.create_or_alter_table_name4_data[params["index"]][1]
        let value = null
        if (index === 'open') {value = "开仓阶段"}
        else if (index === 'close') {value = "平仓阶段"}
        else {value = "不识别的订单执行阶段"}

        return h("div", [
          this.$createElement(
            "span",
            {
              style: {
                marginRight: "5px"
              },
            },
            value
          )
        ]);
      }
      this.create_or_alter_table_name4_columns[2]["render"] = (h, params) => {
        var index = this.create_or_alter_table_name4_data[params["index"]][2][0]
        var value_1 = this.$mul(Number(this.create_or_alter_table_name4_data[params["index"]][2][1]), 10000) + " ‱"
        var value_2 = this.$mul(Number(this.create_or_alter_table_name4_data[params["index"]][2][2]), 10000) + " ‱"
        let value = store.state.function_type_index[index]
        return h("div", [
          this.$createElement(
            "span",
            {
              style: {
                marginRight: "5px"
              },
            },
            value + ",    \t" + value_1 + ",    \t" + value_2
          )
        ]);
      }
      this.create_or_alter_table_name4_columns[3]["render"] = (h, params) => {
        return h("div", [
          this.$createElement(
            "Button",
            {
              props: {
                type: "success",
                size: "small",
                loading: false,
              },
              style: {
                marginRight: "5px"
              },
              on: {
                click: () => {
                  var value = this.create_or_alter_table_name4_data[params["index"]]
                  // 打开指标设置页面modal
                  this.modal_view_msg["uuid"] = value[0]
                  this.modal_view_msg["name"] = ""
                  this.modal_view_msg["m_type"] = "function_type"
                  this.modal_view_msg["paras"] = value[2]
                  this.modal_view_msg["execute_percent"] = 1
                  this.modal_view_msg["open_or_close"] = value[1]
                  this.modal_view_msg["open_modal_switch"] = true
                }
              },
            },
            "设置"
          )
        ]);
      };
    },
    create_or_alter_table_name5_init_table_func: function() {
      // 初始化创建/修改策略标签页内的平仓表格
      const name_array = this.create_or_alter_table_name5_array;
      this.create_or_alter_table_name5_columns = [];
      for (var i = 0; i < name_array.length; i++) {
        this.create_or_alter_table_name5_columns.push({
          title: name_array[i],
          key: name_array[i],
          align: "center"
        });
      }
      // uuid, 账户编号、账户说明、开仓比例、操作
      this.create_or_alter_table_name5_columns[0]["tooltip"] = true;
      this.create_or_alter_table_name5_columns[0]["width"] = 100;
      this.create_or_alter_table_name5_columns[3]["render"] = (h, params) => {
        var name5_value = this.create_or_alter_table_name5_data[params["index"]]
        return h("div", [
          h(flexible_render_slider_view,{
              props: {
                value:name5_value[3],
                index:params["index"],
              },
              on:{
                  slider_change:(msg) => {
                    if (name5_value[0] != this.default_control_name5_uuid) {
                      for (var i = 0; i < this.create_or_alter_table_msg.length; i++) {
                        if (this.create_or_alter_table_msg[i]["uuid"] === name5_value[0] && 
                            this.create_or_alter_table_msg[i]["paras"][0] === name5_value[1] ) {
                            this.create_or_alter_table_msg[i]["paras"][1] = msg["value"]
                            break
                        }
                      }
                    } else {
                      for (var i = 0; i < this.create_or_alter_table_msg.length; i++) {
                        if (this.create_or_alter_table_msg[i]["type"] === "account_msg" &&
                            this.create_or_alter_table_msg[i]["uuid"] != name5_value[0]) {
                            this.create_or_alter_table_msg[i]["paras"][1] = msg["value"]
                        }
                      }
                      // 重新渲染表格
                      this.update_create_or_alter_table_msg()
                    }
                  }
                }
            },
          )
        ])
      };
      this.create_or_alter_table_name5_columns[4]["render"] = (h, params) => {
        if (this.create_or_alter_table_name5_data[params["index"]][0] != this.default_control_name5_uuid) {
          return h("div", [
            this.$createElement(
              "Button",
              {
                props: {
                  type: "warning",
                  size: "small",
                  loading: false
                },
                style: {
                  marginRight: "5px"
                },
                on: {
                  click: () => {
                    var uuid = this.create_or_alter_table_name5_data[params["index"]][0]
                    // 根据UUID删除该项，之后更新table
                    for (var i = 0; i < this.create_or_alter_table_msg.length; i++) {
                      if (this.create_or_alter_table_msg[i]["uuid"] === uuid) {
                          this.create_or_alter_table_msg.splice(i, 1)
                          break
                      }
                    }
                    this.update_create_or_alter_table_msg()
                  }
                }
              },
              "删除"
            )
          ]);
        }
      };
    },
    current_strategy_init_table_func: function() {
      // 初始化当前策略的表格
      const name_array = this.current_strategy_array;
      this.current_strategy_columns = [];
      for (var i = 0; i < name_array.length; i++) {
        this.current_strategy_columns.push({
          title: name_array[i],
          key: name_array[i],
          align: "center"
        })
      }
      // "策略ID","名称","描述","参数","标的", "运行操作","其他操作"
      this.current_strategy_columns[1]["tooltip"] = true;
      this.current_strategy_columns[2]["tooltip"] = true;
      this.current_strategy_columns[3]["tooltip"] = true;
      
      this.current_strategy_columns[4]["render"] = (h, params) => {
        var current_symbol = this.current_strategy_data_show[params["index"]][4]
        return h("div", [
          this.$createElement(
            "span",
            {
              props: {
               
              },
              style: {
                color:"#2b85e4",
                "font-size":"14px",
                "font-weight":"bold"
              },
              on: {
                
              },
            },
            current_symbol.replace("USDT", "") + "_USDT"
          )
        ]);
      };
      this.current_strategy_columns[5]["render"] = (h, params) => {
        var status_code = Number(this.current_strategy_data_show[params["index"]][5])
        // 0:待启动 1:正在运行 2:历史策略 3:已删除
        if (status_code == 1) {
          // 开启 设置 监控 关闭
          var str_status = "已启动"
        } else {
          var str_status = "待启动"
        }
        var _color = str_status == "已启动"?"#19be6b":"#ff9900"
        return h("div", [
          this.$createElement(
            "span",
            {
              props: {
               
              },
              style: {
                color:_color,
                "font-size":"14px",
                "font-weight":"bold"
              },
              on: {
                
              },
            },
            str_status
          )
        ]);
      };

      this.current_strategy_columns[6]["minWidth"] = 130;
      this.current_strategy_columns[6]["render"] = (h, params) => {
        var current_symbol = this.current_strategy_data_show[params["index"]][4]
        var status_code = Number(this.current_strategy_data_show[params["index"]][5])
        var disabled_style = null
        // 0:待启动 1:正在运行 2:历史策略 3:已删除
        if (status_code == 0) {
          // 开启 设置 监控 关闭
          disabled_style = [false, false, false, true]
        } else if (status_code == 1) {
          disabled_style = [true, false, false, false]
        } else {
          disabled_style = [true, true, true, true]
        }
        return h("div", {
          style: {
              display: "flex",
              "justify-content": "space-around",
              "align-items": "center"
          }
        },[
          this.$createElement(
            "Button",
            {
              props: {
                //type: "error",
                size: "small",
                loading: false,
                disabled: disabled_style[0]
              },
              style: {
              },
              on: {
                click: () => {
                  this.create_or_alter_table_strategy_id = this.current_strategy_data_show[params["index"]][0]
                  //'此操作将启动 '+this.create_or_alter_table_strategy_id+" 号策略,是否继续?"
                  this.params_confirm_modal_view_msg['title'] = [this.create_or_alter_table_strategy_id, current_symbol.replace("USDT", "") + "_USDT"]
                  this.params_confirm_modal_view_msg['params'] = this.all_strategy[this.create_or_alter_table_strategy_id]
                  this.params_confirm_modal_view_msg['allow_msg_name_description_index'] = this.allow_msg_name_description_index
                  this.params_confirm_modal_view_msg['open_modal_switch'] = true
                }
              },
            },
            "开启"
          ),
          this.$createElement(
            "Button",
            {
              props: {
                // type: "warning",
                size: "small",
                loading: false,
                disabled: disabled_style[1]
              },
              style: {
              },
              on: {
                click: () => {
                  this.create_or_alter_table_strategy_id = this.current_strategy_data_show[params["index"]][0]
                  this.current_tabs_name = "name3"
                }
              }
            },
            "设置"
          ),
          this.$createElement(
            "Button",
            {
              props: {
                // type: "warning",
                size: "small",
                loading: false,
                disabled: disabled_style[2]
              },
              style: {
              },
              on: {
                click: () => {
                  this.supervisor_strategy_id = this.current_strategy_data_show[params["index"]][0]
                  this.current_tabs_name = "name4"
                }
              }
            },
            "监控"
          ),
          this.$createElement(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
                loading: false,
                disabled: disabled_style[3]
              },
              style: {
              },
              on: {
                click: () => {
                  this.create_or_alter_table_strategy_id = this.current_strategy_data_show[params["index"]][0]
                  this.$Modal.confirm({
                      title: '提示',
                      okText: '确定',
                      cancelText: '取消',
                      content: '此操作将关闭 '+this.create_or_alter_table_strategy_id+" 号策略,是否继续?",
                      onOk: () => {
                          this.current_strategy_table_end_click(this.create_or_alter_table_strategy_id)
                      },
                      onCancel: () => {
                        this.$Message.success({
                          content: "已取消本次操作",
                          duration: 2,
                          background: true,
                        })
                      }
                  })
                }
              }
            },
            "关闭"
          ),
        ]);
      };
      this.current_strategy_columns[7]["render"] = (h, params) => {
        var status_code = Number(this.current_strategy_data_show[params["index"]][5])
        var disabled_style = null
        // 0:待启动 1:正在运行 2:历史策略 3:已删除
        if (status_code == 1) {
          // 开启 设置 监控 关闭
          disabled_style = true
        } else {
          disabled_style = false
        }
        return h("div",[
          this.$createElement(
            "Button",
            {
              props: {
                type: "text",
                loading: false,
                size:"large",
                shape:"circle",
                icon:"md-trash",
                disabled: disabled_style
              },
              style: {
                "font-size":"20px",
                "box-shadow":"none",
              },
              on: {
                click: async () => {
                  // 将当前策略移植到历史策略页面中
                  var strategy_id = Number(this.current_strategy_data_show[params["index"]][0])
                  await this.set_strategy_status_code(2, strategy_id)
                  let data = await this.create_or_alter_table_get_all_strategy(strategy_id)
                  this.all_strategy[strategy_id.toString()] = data
                  this.update_strategy_table_msg()
                }
              },
            }
          )
        ]);
      };
    },
    historical_strategy_init_table_func: function() {
      // 初始化当前策略的表格
      const name_array = this.historical_strategy_array;
      this.historical_strategy_columns = [];
      for (var i = 0; i < name_array.length; i++) {
        this.historical_strategy_columns.push({
          title: name_array[i],
          key: name_array[i],
          align: "center"
        })
      }
      // "策略ID","名称","描述","参数","运行操作","其他操作"
      this.historical_strategy_columns[1]["tooltip"] = true;
      this.historical_strategy_columns[2]["tooltip"] = true;
      this.historical_strategy_columns[3]["tooltip"] = true;
      this.historical_strategy_columns[5]["minWidth"] = 130;
      this.historical_strategy_columns[5]["render"] = (h, params) => {
        return h("div", {
          style: {
              display: "flex",
              "justify-content": "space-around",
              "align-items": "center"
          }
        },[
          this.$createElement(
            "Button",
            {
              props: {
                type: "warning",
                size: "small",
                loading: false,
              },
              style: {

              },
              on: {
                click: () => {
                  this.create_or_alter_table_strategy_id = this.historical_strategy_data_show[params["index"]][0]
                  this.current_tabs_name = "name3"
                }
              }
            },
            "设置"
          )
        ]);
      };
      this.historical_strategy_columns[6]["render"] = (h, params) => {
        return h("div",[
          this.$createElement(
            "Button",
            {
              props: {
                type: "text",
                loading: false,
                size:"large",
                shape:"circle",
                icon:"md-arrow-back",
              },
              style: {
                "font-size":"20px",
                "box-shadow":"none",
              },
              on: {
                click: async () => {
                  // 将历史策略返回到当前策略中
                  var strategy_id = Number(this.historical_strategy_data_show[params["index"]][0])
                  await this.set_strategy_status_code(0, strategy_id)
                  let data = await this.create_or_alter_table_get_all_strategy(strategy_id)
                  this.all_strategy[strategy_id.toString()] = data
                  this.update_strategy_table_msg()
                }
              },
            }
          ),
          this.$createElement(
            "Button",
            {
              props: {
                type: "text",
                loading: false,
                size:"large",
                shape:"circle",
                icon:"md-trash",
              },
              style: {
                "font-size":"20px",
                "box-shadow":"none",
              },
              on: {
                click: async () => {
                  // 将历史策略从前端展示中直接删除
                  var strategy_id = Number(this.historical_strategy_data_show[params["index"]][0])

                  this.$Modal.confirm({
                      title: '提示',
                      okText: '确定',
                      cancelText: '取消',
                      content: '此操作将删除 '+strategy_id+" 号策略,是否继续?",
                      onOk: async () => {
                          await this.set_strategy_status_code(3, strategy_id)
                          let data = await this.create_or_alter_table_get_all_strategy(strategy_id)
                          this.all_strategy[strategy_id.toString()] = data
                          this.update_strategy_table_msg()
                      },
                      onCancel: () => {
                        this.$Message.success({
                          content: "已取消本次操作",
                          duration: 2,
                          background: true,
                        })
                      }
                  })
                }
              },
            }
          )
        ]);
      };
    },
    supervisor_strategy_init_table_func: function() {
      // 初始化当前策略的表格
      const name_array = this.supervisor_strategy_array;
      this.supervisor_strategy_columns = [];
      for (var i = 0; i < name_array.length; i++) {
        this.supervisor_strategy_columns.push({
          title: name_array[i],
          key: name_array[i],
          tooltip:true,
          align: "center"
        })
      }
      // "账户编号", "方向","仓位信息","下单标的","成本价",
      // "现价","止盈价","止损价","最大亏损""信息","未实现盈亏","执行进度"
      this.supervisor_strategy_columns[1]["render"] = (h, params) => {
        var value = params["row"][params["column"]["key"]];
        var buy_sell = params["row"]["方向"].toLowerCase();
        var color;
        if (buy_sell.indexOf("buy") != -1) {
          color = "#006633";
        } else {
          color = "#ed4014";
        }
        if (buy_sell == "空仓") {
          color = "#000000";
        }
        return h("div", [
          h(
            "span",
            {
              style: {
                color: color,
              },
            },
            value
          ),
        ]);
      };
      this.supervisor_strategy_columns[2]["render"] = (h, params) => {
        //当前真实持仓占据账户余额的百分比,设计初始开仓数量占据账户余额的百分比,当前真实持仓数量
        var value = params["row"][params["column"]["key"]]
        return h("div", [
            h(flexible_render_table_view_amount,{
                props: {
                  binance_data:value
                },
                on:{

                }
              },
            )
          ]);
        // var color;
        // if (buy_sell.indexOf("buy") != -1) {
        //   color = "#006633";
        // } else {
        //   color = "#ed4014";
        // }
        // if (buy_sell == "空仓") {
        //   color = "#000000";
        // }
        // return h("div", [
        //   h(
        //     "span",
        //     {
        //       style: {
        //         color: color,
        //       },
        //     },
        //     value[0]
        //   ),
        // ]);
      };
      this.supervisor_strategy_columns[4]["render"] = (h, params) => {
        var value = params["row"][params["column"]["key"]]
        return h("div", [
          h(
            "span",
            {
              style: {},
            },
            value
          ),
        ]);
      }
      this.supervisor_strategy_columns[8]["minWidth"] = 80
      this.supervisor_strategy_columns[8]["render"] = (h, params) => {
        var value = params["row"][params["column"]["key"]];
        var color;
        if (value.toString().indexOf("共计") === -1) {
          color = null;
        }
        else if (value.toString().indexOf("-") != -1) {
          color = "#006633";
        } else {
          color = "#ed4014";
        }
        return h("div", [
          h(
            "span",
            {
              style: {
                color: color,
              },
            },
            value
          ),
        ]);
      };
      this.supervisor_strategy_columns[10]["render"] = (h, params) => {
        var value = params["row"][params["column"]["key"]];
        var color;
        if (value.toString().indexOf("-") === -1) {
          color = "#006633";
        } else {
          color = "#ed4014";
        }
        return h("div", [
          h(
            "span",
            {
              style: {
                color: color,
              },
            },
            value
          ),
        ]);
      };
      this.supervisor_strategy_columns[10]["minWidth"] = 80

      this.supervisor_strategy_columns[11]["minWidth"] = 80
      this.supervisor_strategy_columns[11]["render"] = (h, params) => {
        var value = params["row"]["执行进度"];
        if (value[1] == 0) {
          var percent = 100;
        } else if (value[0] == value[1]) {
          var percent = 100;
        } else {
          var percent = this.$div(this.$mul(100, Number(value[0])), value[1]);
          percent = Math.floor(percent)
        }
        if (percent < 100) {
          status = "active"
        } else {
          status = "success"
        }
        return h("div", [
          this.$createElement("Progress", {
            props: {
              percent: percent,
              status: "active",
            },
            style: {},
            ref: "personal_drive_show_progress",
          }),
        ]);
      }

    },
    model_click_strategy_msg: async function() {
      // 在strategy_msg下单击了model_click确定按钮
      // 将创建/修改的命令传递到后台
      var formData = new FormData();
      var uuid = this.get_uuid();
      if (this.create_or_alter_table_strategy_id.toString() == "-1") {
        formData.append("mode", "create_one_strategy");
        formData.append("data", JSON.stringify({ 
          "strategy_msg":this.create_or_alter_table_msg,
          "uuid":uuid
        }));
        this.confirm_modal_view_msg["title"] = "创建新策略"
      } else {
        formData.append("mode", "alter_one_strategy");
        formData.append("data", JSON.stringify({ 
          "strategy_id": this.create_or_alter_table_strategy_id,
          "strategy_msg":this.create_or_alter_table_msg,
          "uuid":uuid
        }));
        this.confirm_modal_view_msg["title"] = "修改" + this.create_or_alter_table_strategy_id + "号策略"
      }
      let data = await this.$axios({
          url: this.$store.state.urlPort + "/flexible_strategy",
          method: "POST",
          data: formData,
        })
      if (data["status"] == false) {
        this.$Message.warning({
          content: data["msg"],
          duration: 5,
          closable: true,
          background: true,
        })
      } else {
        this.$Message.success({
          content: data["msg"],
          duration: 3,
          closable: true,
          background: true,
        })
      }
      this.confirm_modal_view_msg["params"] = {"uuid":uuid}
      this.confirm_modal_view_msg["open_modal_switch"] = true
    },
    modal_click: async function(value) {
      if (value["mode"] != "ok") {
        this.modal_view_msg["open_modal_switch"] = false
        return null
      }
      if (value["m_type"] === "strategy_msg") {
        // 用户单击了确认创建/修改按钮
        for (var i = 0; i < this.create_or_alter_table_msg.length; i++) {
          if (this.create_or_alter_table_msg[i]["type"] === "strategy_msg") {
              this.create_or_alter_table_msg[i]["paras"]["current_symbol"] = value["paras"]["current_symbol"]
              this.create_or_alter_table_msg[i]["paras"]["description"] = value["paras"]["description"]
              this.create_or_alter_table_msg[i]["paras"]["name"] = value["paras"]["name"]
              break
          }
        }
        // 根据创建新策略/修改既有策略的场景，将create_or_alter_table_msg传递到后台执行
        await this.model_click_strategy_msg()
      } else if (value["m_type"] === "select_strategy_msg") {
        this.create_or_alter_table_strategy_id = value["select_strategy"]["id"]
      } else if (value["m_type"] === "tornado_setting") {
        var formData = new FormData();
        formData.append("mode", "set_settings");
        formData.append("data", JSON.stringify({ 
          "default_strategy_id": value["paras"][0],
        }));
        let data = await this.$axios({
          url: this.$store.state.urlPort + "/flexible_strategy",
          method: "POST",
          data: formData,
        })
        this.$Message.success('设置成功');
      } else {
        for (var i = 0; i < this.create_or_alter_table_msg.length; i++) {
          if (this.create_or_alter_table_msg[i]["uuid"] === value["uuid"]) {
              this.create_or_alter_table_msg[i]["paras"] = value["paras"]
              if (this.create_or_alter_table_msg[i].execute_percent !== undefined) {
                this.create_or_alter_table_msg[i]["execute_percent"] = value["execute_percent"]
              }
              this.$Message.success('success');
              break
          }
        }
        // 重新渲染表格
        this.update_create_or_alter_table_msg()
      }
      this.modal_view_msg["open_modal_switch"] = false
    },
    modal_confirm_click: function(value) {
      if (value["mode"] != "ok") {
        this.confirm_modal_view_msg["open_modal_switch"] = false
        return null
      }
      setTimeout(async () => {
        if (this.create_or_alter_table_strategy_id.toString() == "-1") {
          this.all_strategy = await this.create_or_alter_table_get_all_strategy()
        } else {
          let data = await this.create_or_alter_table_get_all_strategy(this.create_or_alter_table_strategy_id)
          this.all_strategy[this.create_or_alter_table_strategy_id.toString()] = data
        }
        this.update_strategy_table_msg()
      }, 0);
      this.confirm_modal_view_msg["open_modal_switch"] = false
    },
    params_modal_confirm_click: function(value) {
      if (value["mode"] != "ok") {
        this.$Message.success({
          content: "已取消本次操作",
          duration: 2,
          background: true,
        })
      } else {
        this.current_strategy_table_start_click(this.create_or_alter_table_strategy_id)  
      }
      this.params_confirm_modal_view_msg["open_modal_switch"] = false
    },
    get_uuid: function() {
      var d = new Date().getTime();
      var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = (d + Math.random()*16)%16 | 0;
        d = Math.floor(d/16);
        return (c=='x' ? r : (r&0x3|0x8)).toString(16);
      });
      return "_fle_" + uuid;
    },
    check_account_msg: function(strategy_msg) {
      var acc_index = {}
      //对策略参数信息内的可执行账户进行鉴权、裁剪
      for (var i = 0; i < this.allow_msg["account_msg"].length; i++) {
        acc_index[this.allow_msg["account_msg"][i][0]] = this.allow_msg["account_msg"][i][1]
      }
      var new_strategy_msg = []
      var _strategy_msg = null
      for (var _strategy_index in strategy_msg) {
        _strategy_msg = strategy_msg[_strategy_index]
        if (_strategy_msg["type"] === "account_msg" && !(_strategy_msg["paras"][0] in acc_index)) {
            continue
        }
        else {
          new_strategy_msg.push(_strategy_msg)
        }
      }
      return this.account_msg_drop_duplicates(new_strategy_msg)
    },
    account_msg_drop_duplicates: function(strategy_msg) {
      // 对添加的账户户名进行去重
      var acc_index = {}
      var new_strategy_msg = []
      var _strategy_msg = null
      for (var _strategy_index in strategy_msg) {
        _strategy_msg = strategy_msg[_strategy_index]
        if (_strategy_msg["type"] != "account_msg") {
          new_strategy_msg.push(_strategy_msg)
        }
        else {
          if (_strategy_msg["paras"][0] in acc_index) {
            continue
          } else {
            new_strategy_msg.push(_strategy_msg)
            acc_index[_strategy_msg["paras"][0]] = 1
          }
        }
      }
      return new_strategy_msg
    },
    create_or_alter_table_get_strategy_msg: function(strategy_id) {
      // 从接口获得展示在前端界面上的策略参数信息
      if (this.all_strategy == null || strategy_id in this.all_strategy == false) {
        return []
      } else {
        return JSON.parse(JSON.stringify(this.all_strategy[strategy_id.toString()]))
      }
    },
    create_or_alter_table_get_all_allow_msg: async function() {
      // 从接口获得该登陆账户可以使用的所有账户、信号清单
      //get_all_allow_msg
      var formData = new FormData();
      formData.append("mode", "get_allow_msg");
      let data = await this.$axios({
          url: this.$store.state.urlPort + "/flexible_strategy",
          method: "POST",
          data: formData,
        })
      var tmp = data["data"]
      // 通过目前用户使用的信号频率，对默认信号的顺序进行排序
      for (var sign_name of ["open", "close"]) {
        var sort_index = {}
        for (var i in tmp["sign"][sign_name]) {
          sort_index[tmp["sign"][sign_name][i][0]] = 0
        }
        for (var i in this.all_strategy) {
          var con = this.all_strategy[i]
          for (var j in con) {
            if (con[j]["type"] == "sign" && con[j]["open_or_close"] == sign_name) {
              sort_index[con[j]["name"]] += 1
            }
          }
        }
        tmp["sign"][sign_name].sort(function(a, b){return sort_index[b[0]] - sort_index[a[0]]})
      }
      return tmp
    },
    create_or_alter_table_get_all_strategy: async function (strategy_id = "all") {
      // 获取所有该登陆账户可以操作的策略详情
      var formData = new FormData();
      formData.append("mode", "get_strategys");
      formData.append("data", JSON.stringify({ "strategy_id": strategy_id }));
      let data = await this.$axios({
          url: this.$store.state.urlPort + "/flexible_strategy",
          method: "POST",
          data: formData,
        })
      return data["data"]
    },
    supervisor_strategy_get_msg: async function() {
      // 从接口获得当前被监控策略的最新状态,
      // 当前选择的是supervisor_strategy_id
      if (this.supervisor_strategy_id.toString() == "-1") {
        return []
      }
      // "账户编号", "方向","数量","下单标的","成本价",
      // "现价","止盈价","止损价","信息","未实现盈亏","执行进度"
      var formData = new FormData();
      formData.append("mode", "get_supervisor_strategy_msg");
      formData.append("data", JSON.stringify({ "strategy_id": this.supervisor_strategy_id }));
      let data = await this.$axios({
          url: this.$store.state.urlPort + "/flexible_strategy",
          method: "POST",
          data: formData,
        }).catch(data => {
          return {"data":null}
        })
      return data["data"]
    },
    loop_update_supervisor_strategy: function() {
      // 根据现在用户打开的界面+倒计时情况,判断是否需要刷新一次监控界面
      if (this.current_tabs_name != "name4" || this.supervisor_strategy_id.toString() === "-1" || 
          this.loop_update_supervisor_button_loading === true) {
        return null
      }
      if (this.loop_update_supervisor_strategy_time_count > 0) {
        this.loop_update_supervisor_strategy_time_count -= 1
      } else {
        // 每N秒刷新一次
        this.loop_update_supervisor_strategy_time_count = this.loop_update_supervisor_strategy_time_count_set
        this.loop_update_supervisor_button_click()
      }
    },
    loop_update_supervisor_button_click: function() {
      // 刷新按钮被单击，刷新一次监控项
      this.loop_update_supervisor_button_loading = true
      setTimeout(async () => {
        await this.update_supervisor_strategy_table_msg()
        this.loop_update_supervisor_button_loading = false
      }, 1000);
    },
    loop_update_current_strategy_click: function() {
      if (this.current_tabs_name != "name1" || this.loop_update_current_strategy_loading === true) {
        return null
      }
      if (this.loop_update_current_strategy_click_time_count > 0) {
        this.loop_update_current_strategy_click_time_count -= 1
      } else {
        // 每N秒刷新一次
        this.loop_update_current_strategy_click_time_count = this.loop_update_current_strategy_click_time_count_set
        this.update_current_strategy_click()
      }
    },
    update_current_strategy_click: function() {
      // 刷新按钮被单击，刷新一次所有策略
      this.loop_update_current_strategy_loading = true
      this.loop_update_historical_strategy_loading = true
      setTimeout(async () => {
        this.all_strategy = await this.create_or_alter_table_get_all_strategy()
        this.update_strategy_table_msg()
        this.loop_update_current_strategy_loading = false
        this.loop_update_historical_strategy_loading = false
      }, 800);
    },
    setTimer: function(interval, timer) {
      if (timer == null) {
        timer = setInterval(() => {
          this.loop_update_supervisor_strategy()
          this.loop_update_current_strategy_click()
        }, interval);
      }
    },
    current_strategy_search_clear: function() {
      // 当前策略页面，单击了取消搜索按钮
      this.current_strategy_search_model = ""
      this.current_strategy_search_click()
    },
    current_strategy_search_click: function() {
      // 当前策略页面中，单击了搜索按钮
      // 关键字
      if (this.current_strategy_search_model == null || this.current_strategy_search_model.length === 0) {
        this.current_strategy_data_show = JSON.parse(JSON.stringify(this.current_strategy_data))
      } else {
        var data = []
        for (var i = 0; i < this.current_strategy_data.length; i++) {
          var tmp = JSON.parse(JSON.stringify(this.current_strategy_data[i]))
          for (var j = 0; j < tmp.length; j++) {
            if (tmp[j].toString().indexOf(this.current_strategy_search_model) != "-1" || 
                tmp[j].toString().indexOf(this.current_strategy_search_model.toUpperCase()) != "-1") {
                data.push(tmp)
                break
            }
          }
          this.current_strategy_data_show = data
        }
      }
    },
    historical_strategy_search_clear: function() {
      // 历史策略页面，单击了取消搜索按钮
      this.historical_strategy_search_model = ""
      this.historical_strategy_search_click()
    },
    historical_strategy_search_click: function() {
      // 历史策略页面中，单击了搜索按钮
      // 关键字
      if (this.historical_strategy_search_model == null || this.historical_strategy_search_model.length === 0) {
        this.historical_strategy_data_show = JSON.parse(JSON.stringify(this.historical_strategy_data))
      } else {
        var data = []
        for (var i = 0; i < this.historical_strategy_data.length; i++) {
          var tmp = JSON.parse(JSON.stringify(this.historical_strategy_data[i]))
          for (var j = 0; j < tmp.length; j++) {
            if (tmp[j].toString().indexOf(this.historical_strategy_search_model) != "-1" || 
                tmp[j].toString().indexOf(this.historical_strategy_search_model.toUpperCase()) != "-1") {
                data.push(tmp)
                break
            }
          }
          this.historical_strategy_data_show = data
        }
      }
    },
    current_strategy_table_start_click: async function(str_id) {
      // 当前策略页面中，单击了开始按钮
      var msg = this.all_strategy[str_id]
      var strategy_msg = this.get_strategy_msg(msg)
      if (strategy_msg["paras"]["current_status_code"].toString() != "0") {
        console.log("wrong status_code in start func")
        return null
      }
      //调用API拉起策略
      let uuid = this.get_uuid()
      var formData = new FormData()
      formData.append("mode", "start_one_strategy")
      formData.append("data",JSON.stringify({
        "uuid":uuid,
        "strategy_id":str_id
      }))
      let data = await this.$axios({
          url: this.$store.state.urlPort + "/flexible_strategy",
          method: "POST",
          data: formData,
        })
      if (data["status"] == true) {
        this.$Message.success({
            content: data["msg"],
            background: true,
            duration: 6,
        })
        this.confirm_modal_view_msg["params"] = {"uuid":uuid}
        this.confirm_modal_view_msg["title"] = "启动" + str_id + "号策略"
        this.confirm_modal_view_msg["open_modal_switch"] = true
      } else {
        this.$Message.error({
            content: data["msg"],
            background: true,
            duration: 6,
        })
      }
    },
    current_strategy_table_end_click: async function(str_id) {
      // 当前策略页面中，单击了关闭按钮
      var msg = this.all_strategy[str_id]
      var strategy_msg = this.get_strategy_msg(msg)
      if (strategy_msg["paras"]["current_status_code"].toString() != "1") {
        console.log("wrong status_code in end func")
        return null
      }
      //调用API关闭策略
      let uuid = this.get_uuid()
      var formData = new FormData()
      formData.append("mode", "end_one_strategy")
      formData.append("data",JSON.stringify({
        "strategy_id":str_id
      }))
      let data = await this.$axios({
          url: this.$store.state.urlPort + "/flexible_strategy",
          method: "POST",
          data: formData,
        })
      if (data["status"] == true) {
        this.$Message.success({
            content: data["msg"],
            background: true,
            duration: 6,
        })
      } else {
        this.$Message.error({
            content: data["msg"],
            background: true,
            duration: 6,
        })
      }
    },
    set_strategy_status_code: async function(status_code, strategy_id) {
      // status_code==0:历史策略变为待启动
      // status_code==2:待启动策略变为历史策略
      // status_code==3:历史策略变为已删除
      // 设置策略的status_code，设计初用于在当前策略/历史策略的删除按钮上
      // 更改策略的执行状态，由代启动变为历史策略，或者由历史策略变为待启动策略
      
      //to do: 调用API修改策略状态
      if (["0", "2", "3"].indexOf(status_code.toString()) == "-1") {
        return null
      }
      
      var formData = new FormData();
      formData.append("mode", "change_strategy_status");
      formData.append("data", JSON.stringify({ 
        "purpose_status_code": status_code,
        "strategy_id": strategy_id,
      }));
      let data = await this.$axios({
          url: this.$store.state.urlPort + "/flexible_strategy",
          method: "POST",
          data: formData,
        })

      if (data["status"] == false) {
        this.$Message.warning({
          content: data["msg"],
          duration: 5,
          closable: true,
          background: true,
        })
      } else {
        this.$Message.success({
          content: data["msg"],
          duration: 3,
          closable: true,
          background: true,
        })
      }
    },
    calc_allow_msg_description: function() {
      // 通过allow_msg，得到信号name与description的映射
      this.allow_msg_name_description_index = {}
      this.m_allow_msg = JSON.parse(JSON.stringify(this.allow_msg))
      for (var i in this.m_allow_msg["sign"]["open"]) {
        var con = this.m_allow_msg["sign"]["open"][i]
        this.allow_msg_name_description_index[con[0]] = con[2]
      }
      for (var i in this.m_allow_msg["sign"]["close"]) {
        var con = this.m_allow_msg["sign"]["close"][i]
        this.allow_msg_name_description_index[con[0]] = con[2]
      }
      this.allow_msg_name_description_index["stop_loss"] = "固定止损(带推止损)"
      this.allow_msg_name_description_index["stop_gain"] = "固定止盈"
    },
    init_web: function() {
      // 初始化页面时调用
      // 设计初主要用于对上次页面位置的记录, 下次退出登陆尽量保持原样
      var local_save_key = [
        "current_tabs_name", "create_or_alter_table_current_tabs_name", 
        "supervisor_strategy_id", "current_strategy_search_model", 
        "historical_strategy_search_model"
      ]
      for (var i in local_save_key) {
        var data = localStorage.getItem(this.prefix + local_save_key[i])
        if (data != null && data != undefined) {
          this[local_save_key[i]] = data
        }
      }
    }
  },
  mounted() {
    setTimeout(async () => {
        this.all_strategy = await this.create_or_alter_table_get_all_strategy()
        this.allow_msg = await this.create_or_alter_table_get_all_allow_msg()
        this.update_strategy_table_msg()
        this.init_web()
      }, 0);
  },
  watch: {
    allow_msg (new_value) {
      if (this.allow_msg != null) {
        this.calc_allow_msg_description()
      }
    },
    create_or_alter_table_strategy_id (new_value) {
      var new_id = new_value.toString()
      if (new_id == "-1") {
        this.create_or_alter_table_title = "创建新策略"
        this.create_or_alter_table_button_title = "确认创建"
      } else {
        this.create_or_alter_table_title = "修改".concat(new_id, "号策略")
        this.create_or_alter_table_button_title = "确认修改"
      }
      this.create_or_alter_table_click_3()
    },
    supervisor_strategy_id (new_value) {
      // 用户单击了选择录入策略ID的选择框
      this.loop_update_supervisor_button_loading = true
      this.supervisor_strategy_drop_down_title = "加载中..."
      setTimeout(async () => {
        await this.update_supervisor_strategy_table_msg()
        this.loop_update_supervisor_button_loading = false
        this.supervisor_strategy_drop_down_title = new_value + "号策略"
      }, 1000);
      localStorage.setItem(this.prefix + "supervisor_strategy_id", new_value)
    },
    current_tabs_name (new_value, old_value) {
      if (new_value === "name3") {
        this.create_or_alter_table_click_3()
        if (this.create_or_alter_table_current_tabs_name === "create_name5" && this.create_or_alter_table_disabled === true) {
          this.create_or_alter_table_current_tabs_name = "create_name4"
        }
      } else if (new_value === "name1") {
        setTimeout(async () => {
          if (this.supervisor_strategy_id != "-1") {
            let data = await this.create_or_alter_table_get_all_strategy(this.supervisor_strategy_id)
            if (data.length != 0 ) {
              this.all_strategy[this.supervisor_strategy_id.toString()] = data
              this.update_strategy_table_msg()
            }
          }
        }, 0)
      } else if (new_value === "name4") {
        this.loop_update_supervisor_button_click()
      }
      localStorage.setItem(this.prefix + "current_tabs_name", new_value)
    },
    create_or_alter_table_current_tabs_name (new_value, old_value) {
      localStorage.setItem(this.prefix + "create_or_alter_table_current_tabs_name", new_value)
    },
    current_strategy_search_model (new_value, old_value) {
      localStorage.setItem(this.prefix + "current_strategy_search_model", new_value)
    },
    historical_strategy_search_model (new_value, old_value) {
      localStorage.setItem(this.prefix + "historical_strategy_search_model", new_value)
    },
    current_strategy_data (new_value, old_value) {
      this.current_strategy_search_click()
    },
    historical_strategy_data (new_value, old_value) {
      this.historical_strategy_search_click()
    },
  },
  beforeMount: function() {},
  created: function() {
    clearInterval(this.timer);
    this.timer = null;
    this.setTimer(1000, this.timer);
  },
  destroyed() {
    // 每次离开当前界面时，清除定时器
    clearInterval(this.timer);
    this.timer = null;
  }
};
</script>

<style scoped>
.demo-drawer-hearde {
  width: 100%;
  border-bottom: 1px solid #e8e8e8;
  padding-bottom: 10px;
  text-align: right;
  background: #fff;
}
.demo {
  font-size: 10px;
  border: 0px none transparent;
  background-color:transparent;
}
</style>